import { useLanguage } from '@/contexts/LanguageContext';
import { Award } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

export function StepZertifikate({ form, setForm, optionen }) {
  const { t } = useLanguage();

  const toggleZert = (item) => {
    setForm(prev => ({
      ...prev,
      zertifizierungen: prev.zertifizierungen.includes(item)
        ? prev.zertifizierungen.filter(i => i !== item)
        : [...prev.zertifizierungen, item],
    }));
  };

  return (
    <div className="space-y-5" data-testid="step-zertifikate">
      <div className="text-center mb-6">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-3">
          <Award className="h-6 w-6 text-primary" />
        </div>
        <h3 className="font-serif text-xl font-bold text-foreground">{t('dlWizard.step4Title')}</h3>
        <p className="text-sm text-muted-foreground mt-1">{t('dlWizard.step4Desc')}</p>
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-2 block">{t('dlWizard.zertLabel')}</label>
        <div className="flex flex-wrap gap-2" data-testid="zertifizierungen-auswahl">
          {(optionen?.zertifizierungen || []).map((z, i) => {
            const selected = form.zertifizierungen.includes(z);
            return (
              <button
                key={i}
                onClick={() => toggleZert(z)}
                className={`px-3 py-2 text-xs rounded-lg border-2 transition-all ${
                  selected
                    ? 'bg-emerald-50 border-emerald-500 text-emerald-800 font-medium'
                    : 'bg-white border-warm-200 text-foreground hover:border-emerald-300'
                }`}
                data-testid={`zert-${i}`}
              >
                {selected && <Award className="h-3 w-3 mr-1 inline text-emerald-600" />}
                {z}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-1.5 block">{t('dlWizard.zertFreitextLabel')}</label>
        <Input
          value={form.zertifizierungen_freitext}
          onChange={(e) => setForm(p => ({ ...p, zertifizierungen_freitext: e.target.value }))}
          placeholder="z.B. TÜV-Prüfung Seilklettertechnik, FSC-Zertifizierung..."
          data-testid="input-zert-freitext"
        />
      </div>

      <div>
        <label className="text-sm font-medium text-foreground mb-1.5 block">{t('dlWizard.beschreibungLabel')}</label>
        <p className="text-xs text-muted-foreground mb-2">{t('dlWizard.beschreibungDesc')}</p>
        <Textarea
          value={form.beschreibung}
          onChange={(e) => setForm(p => ({ ...p, beschreibung: e.target.value }))}
          placeholder="Beschreiben Sie Ihren Betrieb: Gründungsjahr, Teamgröße, Spezialisierungen, Maschinenpark, besondere Stärken..."
          className="min-h-[140px] resize-y"
          maxLength={5000}
          data-testid="input-beschreibung"
        />
        <p className="text-xs text-muted-foreground text-right mt-1">{form.beschreibung.length} / 5000</p>
      </div>
    </div>
  );
}
